// src/components/menu/AM.tsx

import {
  ArrowBackTwoTone,
  RefreshTwoTone,
  WidthWideTwoTone,
} from '@mui/icons-material'
import { Box, Divider, Fade, ListSubheader, Menu } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { useAppConfig } from '../../hooks'

import { AMItem } from './AMItem'

const reloadPage = () => location.reload()

type AMProps = {
  anchorEl: HTMLElement | null
  caption?: string
  children?: any
  tiny?: boolean
  historyUrlTarget?: string
  historyUrlId?: number
  open: boolean
  onClose: () => void
}

export const AM = ({
  anchorEl,
  caption,
  children,
  tiny = false,
  historyUrlTarget = '',
  historyUrlId,
  open,
  onClose,
}: AMProps) => {
  const { appConfig, setAppConfig } = useAppConfig()

  const navigate = useNavigate()
  let historyUrl = ''

  switch (historyUrlTarget) {
    case 'dashboard':
    case 'folder':
    case 'sensors':
    case 'news':
    case 'users':
    case 'notifications':
    case 'reports':
    case 'virtualsensors':
      historyUrl = `/${historyUrlTarget}`
      break

    case 'feeling':
    case 'security':
    case 'performance':
    case 'installation':
      historyUrl = `/folder/${historyUrlId}/home/${historyUrlTarget}`
      break

    default:
      historyUrl = '/dashboard'
  }

  // handler

  const goBack = () => historyUrl !== '' && navigate(historyUrl)
  const toggleWideScreen = () =>
    setAppConfig(prev => ({ ...prev, wideScreen: !prev.wideScreen }))

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      TransitionComponent={Fade}
      onClose={onClose}
    >
      <ListSubheader>{caption}</ListSubheader>

      {children}

      {!tiny && (
        <Box>
          <Divider />
          <ListSubheader>Seite</ListSubheader>
          <AMItem
            caption={'Wide Screen'}
            icon={<WidthWideTwoTone />}
            onClick={toggleWideScreen}
            selected={appConfig?.wideScreen || false}
          />
          <AMItem
            caption={'Neu laden'}
            icon={<RefreshTwoTone />}
            onClick={reloadPage}
          />
          <AMItem
            caption={'Zurück'}
            icon={<ArrowBackTwoTone />}
            onClick={goBack}
          />
        </Box>
      )}
    </Menu>
  )
}
